<div class="ccmc-search-bar" [ngClass]="{'expanded':!collapsed}">

    <div class="ccmc-search-bar-content" [ngClass]="toolbarColor">

        <label for="ccmc-search-bar-input">
            <button mat-icon-button class="ccmc-search-bar-expander" aria-label="Expand Search Bar" (click)="expand()"
                    *ngIf="collapsed">
                <mat-icon class="s-24">search</mat-icon>
            </button>
            <!--<span class="ccmc-search-bar-loader" fxLayout="row" fxLayoutAlign="center center" *ngIf="!collapsed">
                <mat-progress-spinner color="mat-accent" mode="indeterminate"></mat-progress-spinner>
            </span>-->
        </label>

        <input id="ccmc-search-bar-input" class="ml-24" type="text" placeholder="Search" (input)="search($event)"
               fxFlex>

        <button mat-icon-button class="ccmc-search-bar-collapser" (click)="collapse()"
                aria-label="Collapse Search Bar">
            <mat-icon class="s-24">close</mat-icon>
        </button>

    </div>

</div>